import { Amenity, type AmenityStatus } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { AmenityIcon } from "@hopper-b2b/ui";
import { useTenantIcons } from "@hopper-b2b/utilities";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import styles from "./Features.module.scss";

const BREAKFAST_AMENITIES = new Set<string>([
  Amenity.FreeBreakfast,
  Amenity.PaidBreakfast,
  Amenity.BreakfastIncluded,
]);

interface Props {
  isFreeCancel?: boolean;
  amenities?: AmenityStatus[];
  className?: string;
}

export function Features({ isFreeCancel, amenities, className }: Props) {
  const { t } = useI18nContext();
  const icons = useTenantIcons();

  // At the hotel-list level we only know whether the hotel offers breakfast,
  // not whether it's free or paid — that distinction lives at the room-rate
  // level. Always show "disponível" here; the shop page updates to "incluído"
  // once room data loads and confirms it (NU-147).
  const hasAnyBreakfastAmenity =
    amenities?.some(({ amenity }) => BREAKFAST_AMENITIES.has(amenity)) ?? false;

  return (
    <div className={clsx(styles.Feature, className)}>
      {isFreeCancel && (
        <>
          {icons.greenShieldCheck ? (
            <img src={icons.greenShieldCheck} alt="" />
          ) : null}
          <Typography>{t("freeCancellation")}</Typography>
        </>
      )}
      {hasAnyBreakfastAmenity && (
        <Typography className={styles.BreakfastBadge}>
          <AmenityIcon amenity={Amenity.PaidBreakfast} alt="" />
          {t(
            "core-hotels.availabilityPage.results.hotelCard.features.breakfastAvailable"
          )}
        </Typography>
      )}
    </div>
  );
}
